import { IAddress } from "./address";
import { IEntityDto } from "./base";
import { ITotals } from "./totals";

export interface IOrderTask extends IEntityDto {

  /**
  * @deprecated use orderTaskNumber instead
  */
  abbreviation?: string;
  address?: IAddress;
  bearerId?: number;
  departmentId?: number;
  description?: string;
  details?: string;
  deliveryAddress?: IAddress;
  discountTotal?: number;
  discountTotalPct?: number;
  discountTotalRatio?: number;
  index?: number;
  internalNote?: string;
  invoiceDateDays?: number;
  isConfirmed?: boolean;
  isDelivered?: boolean;
  isInvoiced?: boolean;
  isPlanned?: boolean;
  isReadonly?: boolean;
  marginTotal?: number;
  marginTotalPct?: number;
  marginTotalRatio?: number;
  orderContextType?: string;
  orderId?: number;
  orderNumber?: number;
  orderTaskStatusColor?: string;
  orderTaskStatusId?: number;
  orderTaskStatusName?: string;
  partnerAccountNumber?: number;
  partnerName?: string;
  priceNettTotal?: number;
  printDetails?: boolean;
  projectClosedDateDays?: number;
  projectId?: number;
  purposeId?: number;
  responsibleId?: number;
  responsibleName?: string;
  subscriptionId?: number;
  totals?: ITotals;
  orderTaskNumber?: string;
}
